// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Home-root-_ZJme {
    padding-left: 0px;
    padding-right: 0px;
    overflow-x: hidden;
}

.Home-container-D2D0w {
    width: 100%;
    margin: 0 auto;
    max-width: 1274px;
}

.Home-homePageContainer-uMyvk {
    padding-top: 40px;
    padding-bottom: 40px;
}

.Home-displayGrid-isUcU {
    display: grid;
    grid-template-columns: 24% 24% 24% 24%;
    grid-gap: 17px;
    margin: 0px 6px;
}

.Home-popularGridWidth-AN5mo {
    width: 100%;
    max-width: 1172px;
    margin: 70px auto 40px;
    background-color: var(--primary-gray-bg);
    padding: 41px 58px;
    border-radius: 20px;
    -webkit-box-shadow: 0px 2px 18px var(--primary-box-shadow);
            box-shadow: 0px 2px 18px var(--primary-box-shadow);
    position: relative;
    z-index: 2;
}

.Home-layout2Bottom-W23sE {
    padding-bottom: 80px;
}

.Home-feedbackSpacingContainer-W9hyl {
    padding-bottom: 70px;
}

.Home-skeletonContainerPadding-dJZiW {
    padding: 0px 15px;
}

@media screen and (max-width: 1199px) {
    .Home-popularGridWidthPadding-nf2Db {
        padding: 0px 15px;
    }
}

@media screen and (max-width: 1170px) {
    .Home-containerTitle-g3oEd {
        text-align: center;
    }
}

@media screen and (max-width: 1200px) {
    .Home-layout2Bottom-W23sE {
        padding: 0 15px 80px;
    }
}

@media screen and (max-width: 767px) {
    .Home-marginLeft-dbXJ4 {
        margin: 0 0 24px 34px;
    }

    .Home-displayGrid-isUcU {
        grid-template-columns: 100%;
    }

    .Home-popularGridWidth-AN5mo {
        padding: 50px 20px 20px;
    }

    .Home-containerTitle-g3oEd {
        margin: 0 0 40px;
    }

    .Home-feedbackSpacingContainer-W9hyl {
        padding-bottom: 0;
    }
}`, "",{"version":3,"sources":["webpack://./src/routes/home/Home.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,oBAAoB;AACxB;;AAEA;IACI,aAAa;IACb,sCAAsC;IACtC,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,wCAAwC;IACxC,kBAAkB;IAClB,mBAAmB;IACnB,0DAAkD;YAAlD,kDAAkD;IAClD,kBAAkB;IAClB,UAAU;AACd;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI;QACI,iBAAiB;IACrB;AACJ;;AAEA;IACI;QACI,kBAAkB;IACtB;AACJ;;AAEA;IACI;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI;QACI,qBAAqB;IACzB;;IAEA;QACI,2BAA2B;IAC/B;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,gBAAgB;IACpB;;IAEA;QACI,iBAAiB;IACrB;AACJ","sourcesContent":[".root {\n    padding-left: 0px;\n    padding-right: 0px;\n    overflow-x: hidden;\n}\n\n.container {\n    width: 100%;\n    margin: 0 auto;\n    max-width: 1274px;\n}\n\n.homePageContainer {\n    padding-top: 40px;\n    padding-bottom: 40px;\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: 24% 24% 24% 24%;\n    grid-gap: 17px;\n    margin: 0px 6px;\n}\n\n.popularGridWidth {\n    width: 100%;\n    max-width: 1172px;\n    margin: 70px auto 40px;\n    background-color: var(--primary-gray-bg);\n    padding: 41px 58px;\n    border-radius: 20px;\n    box-shadow: 0px 2px 18px var(--primary-box-shadow);\n    position: relative;\n    z-index: 2;\n}\n\n.layout2Bottom {\n    padding-bottom: 80px;\n}\n\n.feedbackSpacingContainer {\n    padding-bottom: 70px;\n}\n\n.skeletonContainerPadding {\n    padding: 0px 15px;\n}\n\n@media screen and (max-width: 1199px) {\n    .popularGridWidthPadding {\n        padding: 0px 15px;\n    }\n}\n\n@media screen and (max-width: 1170px) {\n    .containerTitle {\n        text-align: center;\n    }\n}\n\n@media screen and (max-width: 1200px) {\n    .layout2Bottom {\n        padding: 0 15px 80px;\n    }\n}\n\n@media screen and (max-width: 767px) {\n    .marginLeft {\n        margin: 0 0 24px 34px;\n    }\n\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n\n    .popularGridWidth {\n        padding: 50px 20px 20px;\n    }\n\n    .containerTitle {\n        margin: 0 0 40px;\n    }\n\n    .feedbackSpacingContainer {\n        padding-bottom: 0;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Home-root-_ZJme`,
	"container": `Home-container-D2D0w`,
	"homePageContainer": `Home-homePageContainer-uMyvk`,
	"displayGrid": `Home-displayGrid-isUcU`,
	"popularGridWidth": `Home-popularGridWidth-AN5mo`,
	"layout2Bottom": `Home-layout2Bottom-W23sE`,
	"feedbackSpacingContainer": `Home-feedbackSpacingContainer-W9hyl`,
	"skeletonContainerPadding": `Home-skeletonContainerPadding-dJZiW`,
	"popularGridWidthPadding": `Home-popularGridWidthPadding-nf2Db`,
	"containerTitle": `Home-containerTitle-g3oEd`,
	"marginLeft": `Home-marginLeft-dbXJ4`
};
module.exports = ___CSS_LOADER_EXPORT___;
